import { useEffect, useRef, useState } from "react";
import { getDecryptedData } from "../../config/crypto";
import { REACT_APP_API_PORT } from "../../Api";
import "react-circular-progressbar/dist/styles.css";
import axios from "axios";
import Loader from "../Loader";
import { useNavigate } from "react-router";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { GrCertificate } from "react-icons/gr";
import { AiOutlineSafetyCertificate } from "react-icons/ai";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import Certificate from "./Certificate";
const CourseCertificate = () => {
    const navigate = useNavigate();
    const [apiIsLoading, setApiIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 5; // Number of records per page
    const certRef = useRef();

    useEffect(() => {
        const getData = async () => {
            try {
                setApiIsLoading(true);
                const token = getDecryptedData("token");
                const res = await axios.get(`${REACT_APP_API_PORT}user/course/order/completed-courses?page=${currentPage}&limit=${limit}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                });
                setApiIsLoading(false);
                if (res.data.status) {
                    setData(res.data.data);
                    setTotalPages(res.data.pagination.totalPages);
                }
            } catch (err) {
                setApiIsLoading(false);
                console.log(err);
            }
        };
        getData();
    }, [currentPage]);

    // Function to handle page change
    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };


  const downloadCertificate = async () => {
    const element = certRef.current;
    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("l", "mm", "a4");
    pdf.addImage(imgData, "PNG", 10, 10, 280, 0);
    pdf.save("certificate.pdf");
  };
    return (
        <div className="container py-4">
            <Loader isLoading={apiIsLoading} />
            {/* <h2 className="text-xl font-semibold mb-4 text-white">Payment History</h2> */}

            <div className="overflow-x-auto">
                <table className="w-full min-w-max  border-white/10  shadow-md border-t-white/10">
                    <thead className="bg-background-back2 text-white">
                        <tr className="text-left border-t-0 border-white/10">
                            <th className="py-3 px-4 border-b border-white/0">Course Name</th>
                            {/* <th className="py-3 px-4 border-b">Course Progress</th> */}
                            <th className="py-3 px-4 border-b border-white/0"> Certificate</th>
                        </tr>
                    </thead>
                    <tbody className="border border-l-white/10 border-white/10">
                        {data.length > 0 ? (
                            data.map((payment, index) => (
                                <tr key={index} className="border-b hover:bg-gray-50 bg-background-back2 text-white">
                                    <td className="py-3 px-4">{payment?.course_name}</td>
                                    {/* <td className="py-3 px-4">{payment?.completionPercentage} %</td> */}
                                    <td className="py-3 px-4">
                                        {/* <button onClick={() => {
                                            downloadCertificate()
                                        }} className="px-3 py-2 border-2 bg-blue-600 text-white rounded flex items-center">Get Certificate <AiOutlineSafetyCertificate className="mx-1" />

                                        </button> */}
                                        <Certificate data={payment}/>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center py-4 text-gray-500">No certificates found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
                <div className="flex justify-center items-center gap-3 mt-4">
                    <button
                        className={`p-2 rounded-md bg-blue-600 text-white border ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}
                        onClick={() => goToPage(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        <FaChevronLeft />
                    </button>

                    <span className="text-gray-700 font-medium">
                        Page {currentPage} of {totalPages}
                    </span>

                    <button
                        className={`p-2 rounded-md  bg-blue-600 text-white border ${currentPage === totalPages ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}
                        onClick={() => goToPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        <FaChevronRight />
                    </button>
                </div>
            )}

     
      {/* Hidden Certificate */}
      <div ref={certRef} className="absolute -left-[9999px]">
        <div className="w-[800px] h-[600px] bg-white border-8 border-gray-700 p-10 text-center shadow-lg">
          <h1 className="text-4xl font-bold uppercase text-gray-800">
            Certificate of Achievement
          </h1>
          <p className="text-lg mt-4 text-gray-600">
            This certificate is proudly presented to
          </p>
          <h2 className="text-3xl font-semibold text-gray-900 mt-6">
           Sachin Sen
          </h2>
          <p className="text-md text-gray-500 mt-6">
            For outstanding performance and dedication in achieving excellence.
          </p>
          <div className="flex justify-between mt-16 px-10">
            <div className="text-center">
              <hr className="w-48 border-t-2 border-gray-600 mb-2" />
              <p className="text-gray-700">Signature</p>
            </div>
            <div className="text-center">
              <hr className="w-48 border-t-2 border-gray-600 mb-2" />
              <p className="text-gray-700">Date</p>
            </div>
          </div>
        </div>
      </div>

        </div>
    );
};

export default CourseCertificate;
